import Promotion from '@/components/sections/Promotion'
import { RelatedFaq } from '@/v1/components/faq'
import { golfStorageFaqs } from '@/v1/components/faq/constants'
import { Benefits, MultiGridCard, WhyUse } from '@/v1/components/ui'
import { PrimaryBanner } from '@/v1/components/ui/banner'
import { BANNERS } from '@/v1/components/ui/banner/constant'
import {
  BENEFITS,
  IMPORTANCE,
  INNOVATIVE,
  PRICING,
  STORAGE_IN_CITY,
  WHY_USE
} from '@/v1/components/ui/section/constants'

export function GolfClubStorageNearMe() {
  return (
    <>
      <PrimaryBanner info={BANNERS.golfClub} />

      <WhyUse info={WHY_USE.golfClub} />

      <MultiGridCard info={PRICING.golfClub.top} />

      <MultiGridCard info={STORAGE_IN_CITY.golfClub} />

      <Benefits info={BENEFITS.golfClub} />

      <MultiGridCard info={IMPORTANCE.golfClub} />

      <MultiGridCard info={INNOVATIVE.golfClub} />

      <MultiGridCard info={PRICING.golfClub.bottom} />

      <RelatedFaq faqs={golfStorageFaqs} className={'lg-mn:grid-cols-1'} />

      <Promotion />
    </>
  )
}
